import { VariableType } from '@/proto/common';
import type { RunStep } from '../../runHistory/runStepUtils';
import { getEnumValues } from '../../variables/variableDefinitions';

/**
 * Returns the label of `status`, an `ALERT_STATUS` enum value. A status the enum lacks logs an
 * error and is returned as stored.
 */
export function getAlertStatusLabel(status: string): string {
  const statusValues = getEnumValues(VariableType.ALERT_STATUS) ?? [];
  const statusValue = statusValues.find(
    (enumValue) => enumValue.value === status
  );
  if (statusValue === undefined) {
    console.error(`Alert status check report has an unknown status: ${status}`);
    return status;
  }
  return statusValue.label;
}

/**
 * Returns "Alert is {status label}" for an alert status check's step, or null if the step has no
 * alert status check report.
 */
export function getAlertStatusRunStepSummary(step: RunStep): string | null {
  const report = step.report?.alert_status_check;
  if (report === undefined) {
    return null;
  }
  return `Alert is ${getAlertStatusLabel(report.status)}`;
}
